/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Document } from '../../core/models/Document';
import { Node } from '../../core/models/Node';
import { ITraverser } from '../../core/visitors/ITraverser';
import { IVisitor } from '../../core/visitors/IVisitor';
import { CombinedAllNodeVisitor } from './CombinedAllNodeVisitor';

/**
 * Constructor.
 * @param {*} visitor
 * @class
 * @extends CombinedAllNodeVisitor
 * @author eric.wittmann@gmail.com
 */
export class CombinedReverseTraverser extends CombinedAllNodeVisitor implements ITraverser {
    visitor : IVisitor;

    public constructor(visitor : IVisitor) {
        super();
        if(this.visitor===undefined) this.visitor = null;
        this.visitor = visitor;
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.ITraverser#traverse(io.apicurio.datamodels.core.models.Node)
     * @param {Node} node
     */
    public traverse(node : Node) {
        node.accept(this);
    }

    /**
     * @see io.apicurio.datamodels.combined.visitors.CombinedAllNodeVisitor#visitNode(io.apicurio.datamodels.core.models.Node)
     * @param {Node} node
     */
    visitNode(node : Node) {
        node.accept(this.visitor);
        this.traverse(node.parent());
    }

    /**
     * @see io.apicurio.datamodels.combined.visitors.CombinedAllNodeVisitor#visitDocument(io.apicurio.datamodels.core.models.Document)
     * @param {Document} node
     */
    public visitDocument(node : Document) {
        node.accept(this.visitor);
    }
}
CombinedReverseTraverser["__class"] = "io.apicurio.datamodels.combined.visitors.CombinedReverseTraverser";
CombinedReverseTraverser["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor","io.apicurio.datamodels.core.visitors.ITraverser","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];




